module.exports = __webpack_public_path__ + "img/pin-bricomarche.caeef4c3.svg";